import React, { useState } from 'react';
import { LegendDiv, LegendTitle, ImgBlock } from './styled/legendstyled';
import { FaRegListAlt } from "react-icons/fa";
import legendpic from './img/mask_example.png';

function LegendLink() {
    // LegendLink開關設計
    const [legend, setLegend] = useState(true);

    // LegendIcon設計
    const LegendIcon = {
        padding: `13px 10px 15px 10px`,
    }
    const LegendStyle = {
        fontSize: `2em`,
    }

    // LegendLink開關function
    function toggle() {
        setLegend(!legend);
    }

    return (
        <>
            <LegendDiv legend={legend} onClick={toggle}>
                {legend ? null : <div style={LegendIcon}><FaRegListAlt style={LegendStyle} /></div>}
                <LegendTitle>{legend ? <div className='useTitle'>圖　例</div> : null}</LegendTitle>
                <ImgBlock legend={legend} src={legendpic} alt=''></ImgBlock>
            </LegendDiv>
        </>
    )
}

export default LegendLink;

